<template>
  <p-product-layout
    data-test-product-layout
    :product="product"
    :supplier-related-products="supplierRelatedProducts"
    :supplier-related-product-count="supplierRelatedProductCount"
    :is-authenticated="isAuthenticated"
    :cooperative-name="cooperativeName"
    :technical-sales="profile.technicalSales"
    :show-technical-sales-contact="showTechnicalSalesContact"
    :similar-products="similarProducts"
    :frequently-bought-together-products="frequentlyBoughtTogetherProducts"
    :banner="banner"
    @login="login()"
    @go-to-product-search="goToProductSearch"
  >
    <template #default>
      <p-product-detail-block-html
        id="product-detail"
        :html="product.description"
        :title="i18n._('Descriptif')"
        data-test="description"
        :format-html="true"
      />
      <p-product-detail-block-html
        :html="product.characteristics"
        :title="i18n._('Caractéristiques')"
        data-test="characteristics"
      />
      <p-product-detail-block-review
        v-if="product.cooperativeReview"
        id="product-review"
        data-test="review"
        :cooperative-review="product.cooperativeReview"
        :cooperative-name="cooperativeName"
      ></p-product-detail-block-review>
      <p-product-detail-block-documentation id="product-documentation" :product="product" data-test="documentation" />
    </template>
  </p-product-layout>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import PProductDetailBlockHtml from '../PProductDetailBlockHtml/PProductDetailBlockHtml.vue'
import PProductDetailBlockReview from '../PProductDetailBlockReview/PProductDetailBlockReview.vue'
import PProductLayout from '../PProductLayout/PProductLayout.vue'
import type { Product, SingleProduct } from '../typings'
import PProductDetailBlockDocumentation from '../PProductDetailBlockDocumentation/PProductDetailBlockDocumentation.vue'
import { i18n } from '@b2ag/locale'
import type { Banner } from '@b2ag/contexts/marketing/src/domain/blocs/Banner'

export default defineComponent({
  name: 'PProductGeneric',
  components: {
    PProductLayout,
    PProductDetailBlockHtml,
    PProductDetailBlockReview,
    PProductDetailBlockDocumentation,
  },
  props: {
    product: {
      type: Object as PropType<SingleProduct>,
      default: () => ({}),
    },
    supplierRelatedProducts: {
      type: Array as PropType<Array<Product>>,
      default: () => [],
    },
    similarProducts: {
      type: Array as PropType<Array<Product>>,
      default: () => [],
    },
    frequentlyBoughtTogetherProducts: {
      type: Array as PropType<Array<Product>>,
      default: () => [],
    },
    supplierRelatedProductCount: {
      type: Number,
      default: 0,
    },
    profile: {
      type: Object,
      default: () => ({}),
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    showTechnicalSalesContact: {
      type: Boolean,
      default: true,
    },
    cooperativeName: {
      type: String,
      default: '',
    },
    banner: {
      type: Object as PropType<Banner>,
      default: () => {},
    },
  },
  setup(_, { emit }) {
    function login(): void {
      emit('login')
    }

    function goToProductSearch(goToProductSearchArgs): void {
      emit('goToProductSearch', goToProductSearchArgs)
    }

    return {
      login,
      goToProductSearch,
      i18n,
    }
  },
})
</script>
